define('app-ShorexSummary/main',['./settings', '../app/ui/dialog', 'jquery-ui'], function (settings, dialog) {
    return {
        run: function () {
            var summary = $(settings.container);

            if (summary.length === 0) {
                window.log('Summary will not be available.');
                return;
            }

            window.log('Loading Shorex summary');

            $("#btnContinueHTML").click(function (event) {
                (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
                checkTermsClick();
            });

            function checkTermsClick() {
                if ($('#cbxConfirm').is(':checked')) {
                    dialog.show("Please wait", "", { noClose: true });
                    var interval;                  
                    clearTimeout(interval);
                    setTimeout(function () { makeReservation(); }, 1000);
                } else {
                    var message = 'Please confirm you have read the terms and conditions',
                        d = $("#MessageDialog").clone(),
                        dhandle = dialog.show('Confirmation Required', message, { onOpen: open }, false, ['modal-closable']);
                    d.show();
                    $(d.find('.closeKey')).click(function () {
                        dhandle.close();
                    });
                    $(".ui-dialog-titlebar-close").hide();
                }
            }

            function makeReservation() {
                window.location.href = $('#nextPageUrl').val();
            }
        }
    };
});
